<template>
  <div id="Delete_popup" class="xv_modal default">
    <div class="modal_title">
      <div>
        <span>Are you sure?</span>
      </div>
      <div>
        <button class="modal_close" @click="close_new_marker()">
          <span class="mdi mdi-close"></span>
        </button>
      </div>
    </div>
    <div class="modal_content">
      <span>{{ delete_text }}</span>
    </div>
    <div class="modal_footer">
      <button class="sec_btn m_r" @click="close_new_marker()">Cancel</button>
      <button class="delete_btn" @click="success = true">Delete</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["delete_text"],
  name: "Delete_popup",
  components: {},
  data() {
    return {};
  },
  methods: {
    close_new_marker: function() {
      this.$modal.hide("delete_popup");
    }
  }
};
</script>
